/**
 * @module reducers
 */

import localforage from 'localforage'
import { DownloadTaskStatus } from 'constants/enums'
import { PLAY_TRIGGERS } from 'constants/tracking'
import { combineReducers } from 'redux'
import { persistReducer, createTransform } from 'redux-persist'
import { reducer as AuthReducer } from 'reducers/Auth'
import { reducer as ReleasesReducer } from 'reducers/Releases'
import { reducer as ProfileReducer } from 'reducers/Profile'
import { reducer as GlobalStateReducer } from 'reducers/GlobalState'
import { reducer as PlayerReducer } from 'reducers/Player'
import { reducer as PlayQueueReducer } from 'reducers/PlayQueue'
import { reducer as PlayListReducer } from 'reducers/PlayList'
import { reducer as SearchReducer } from 'reducers/Search'
import { reducer as FlaggedReducer } from 'reducers/Flagged'
import { reducer as ArchivedReducer } from 'reducers/Archived'
import { reducer as PlayHistoryReducer } from 'reducers/PlayHistory'
import { reducer as SettingReducer } from 'reducers/Setting'
import { reducer as GenreReducer } from 'reducers/Genre'
import { reducer as MarketReducer } from 'reducers/Market'
import { reducer as DownloadsReducer } from 'reducers/Downloads'
import { reducer as NotificationReducer } from 'reducers/Notification'
import { reducer as ModalReducer } from 'reducers/Modal'
import { reducer as TableReducer } from 'reducers/Table'
import { reducer as OptionReducer } from 'reducers/Options'

const markUnfinishedTaskAsError = (download) => {
  if (download.status !== DownloadTaskStatus.finished) {
    return Object.assign({}, download, {
      status: DownloadTaskStatus.failed
    })
  } else {
    return download
  }
}

const DownloadsTransform = createTransform(
  (inboundState) => {
    return Object.assign({}, inboundState, {
      downloads: inboundState.downloads.map(markUnfinishedTaskAsError)
    })
  },
  (outboundState) => {
    return outboundState
  },
  { whitelist: ['downloads'] }
)

/**
 * Persist al of player reducer,
 * and reset state to beginning of current song
 */
export const PlayerTransform = createTransform(
  (inboundState) => {
    return Object.assign({}, inboundState, {
      ...inboundState,
      isPlaying: false,
      currentTime: 0.0,
      seekTime: null,
      volume: inboundState.volume ?? 50,
      previousVolume: inboundState.previousVolume ?? 50,
      isMuted: inboundState.isMuted ?? false,
      autoPlay: inboundState.autoPlay ?? false,
      // The restored song reports Play Song once it is started from the playbar
      pendingPlayTrigger: inboundState.song ? PLAY_TRIGGERS.LAST_SESSION : null
    })
  },
  (outboundState) => outboundState,
  { whitelist: ['player'] }
)

const persistConfig = {
  key: 'root',
  storage: localforage,
  version: 1.0,
  transforms: [DownloadsTransform, PlayerTransform],
  whitelist: [
    'authentication',
    'setting',
    'playHistory',
    'global',
    'playQueue',
    'downloads',
    'search',
    'table',
    'player'
  ]
}

const rootReducer = combineReducers({
  authentication: AuthReducer,
  releases: ReleasesReducer,
  genre: GenreReducer,
  market: MarketReducer,
  flagged: FlaggedReducer,
  archived: ArchivedReducer,
  player: PlayerReducer,
  playList: PlayListReducer,
  search: SearchReducer,
  profile: ProfileReducer,
  playQueue: PlayQueueReducer,
  global: GlobalStateReducer,
  playHistory: PlayHistoryReducer,
  setting: SettingReducer,
  downloads: DownloadsReducer,
  notification: NotificationReducer,
  modal: ModalReducer,
  table: TableReducer,
  options: OptionReducer
})

export default persistReducer(persistConfig, rootReducer)
